const separator = "_aras1mzs6aa";

export { separator };
import "./organism.component-framework-contextmenu.style.linaria.module.css";
//# sourceMappingURL=organism.component-framework-contextmenu.style.js.map
